__turbopack_context__.v({
  "currentPage": "_26JrhG_currentPage",
  "dealspage__pagination": "_26JrhG_dealspage__pagination",
  "firstDots": "_26JrhG_firstDots",
  "fullwidth": "_26JrhG_fullwidth",
  "lastDots": "_26JrhG_lastDots",
  "pagination": "_26JrhG_pagination",
  "paginationWithText": "_26JrhG_paginationWithText",
  "paginationWithoutText": "_26JrhG_paginationWithoutText",
});
